import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './Filter.module.scss';

interface ISelectPickerEmptyState {
  message?: string;
}

const EMPTY_MESSAGE = 'No options available';

const SelectPickerEmptyState = ({ message = EMPTY_MESSAGE }: ISelectPickerEmptyState) => {
  return (
    <div className={styles.selectPickerEmptyState}>
      <Typography variant="p4" color="var(--grayscale-2)">
        {message}
      </Typography>
    </div>
  );
};

export default SelectPickerEmptyState;
